// Deep-link helpers shared by App.js (legacy ?botId= redirects, embedded
// handoffs) and the Live Chat page (notification links /live?bot=..&session=..).

/**
 * Forward a bot id carried in a deep link onto the global bot selector.
 *
 * Writes the id to localStorage FIRST so SelectedBotContext's reconcile step
 * (which reads `selectedBotId` when the bot list arrives) keeps it on a cold
 * load, then dispatches `ub:select-bot` so an already-mounted context switches
 * immediately on in-app navigation. Unknown ids are harmless: reconcile falls
 * back to the first available bot.
 */
export function selectBotFromDeepLink(botId) {
  if (!botId) return;
  const id = String(botId);
  localStorage.setItem("selectedBotId", id);
  localStorage.setItem("selectedBotIds", JSON.stringify([id]));
  window.dispatchEvent(new CustomEvent("ub:select-bot", { detail: { botId: id } }));
}

/**
 * Parse the live-inbox deep link params from a search string:
 * `?bot=<bot_id>&session=<session_id>` (both optional, both strings).
 */
export function parseLiveDeepLink(search) {
  try {
    const params = new URLSearchParams(search || "");
    const botId = (params.get("bot") || "").trim() || null;
    const sessionId = (params.get("session") || "").trim() || null;
    return { botId, sessionId };
  } catch (e) {
    return { botId: null, sessionId: null };
  }
}

/** Build the live-inbox deep link path used by in-app toasts and tests. */
export function buildLiveDeepLink({ botId, sessionId } = {}) {
  const params = new URLSearchParams();
  if (botId) params.set("bot", String(botId));
  if (sessionId) params.set("session", String(sessionId));
  const qs = params.toString();
  return qs ? `/live?${qs}` : "/live";
}
